var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor"},[_c('div',{attrs:{"id":"wangEditor"}}),_vm._v(" "),_c('div',{staticClass:"limitNum"},[_vm._v("已填写"+_vm._s(_vm.spanInfo)+"字 "),(_vm.timeInt)?_c('span',[_vm._v("上次保存时间"+_vm._s(_vm.initTime(_vm.timeInt)))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }